export const GET_PROJECTS = "getProjects";
export const ADD_PROJECT = "addProject";

export const GET_TASKS = "getTasks";
export const ADD_TASK = "addTask";
export const EDIT_TASK = "editTask";

export const NOTIFY = "notify";
